<div class="loadding-container" *ngIf="isLoading">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</div>
<div class="main-container" (mousemove)="onMousemove($event)" (mouseup)="stopDragging($event)"
    (mousemove)="moveEvent($event)">
    <p-toast></p-toast>
    <div #mapPanel [ngClass]="{'mapPanel': true}"></div>
    <div class="current-location" *ngIf="mapView" (click)="findCurrentLocation()">
        <img src="https://cdn-icons-png.flaticon.com/512/535/535239.png" alt="">
    </div>
    <div class="find-news-closest" *ngIf="mapView">
        <button (click)="findClosestNews()" [disabled]="findNewsClosestDisableState">ข่าวบริเวณใกล้เคียง</button>
    </div>

    <div class="extraLayerInfo" *ngIf="isExtraLayerExist">
        <div [innerHTML]="AISerachExtraLayerInfo"></div>
    </div>
    <div class="search-container" [ngClass]="{'searchActive': showSearchResults || showCurrentNews}">
        <button (click)="toggleSearchContainer()" class="toggle-button"
            [ngClass]="{'hidden': !input && !currentNews_link}">
            <img [ngClass]="{'close': !showSearchResults && !showCurrentNews}"
                src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg" alt="toggle-button">
        </button>
        <app-search-box [width]="'570px'" [top]="'20px'" [left]="'15px'" [search_input]="search_input"
            [showBackButton]="true" (onSearch)="onSearchClick($event)" (onAiSearch)="onSearchAIClick($event)"
            (onBackButtonClick)="goBack()"></app-search-box>
        <div class="gap"></div>

        <div class="scroll-container">

            <div *ngIf="notFound && showSearchResults" class="not-found custom-not-found">
                <p>Not Found</p>
            </div>

            <div class="custom-box"
                style="font-size: 16px; font-family: 'IBM Plex Sans Thai'; display: block; white-space: pre-line; position: relative;"
                *ngIf="showAIBox && !showCurrentNews" [class.hidden]="notFound" [innerHTML]="streamDataStr">

            </div>


            <app-list-results *ngIf="showSearchResults && !showCurrentNews" [loading]="loadingSearchNews"
                [results]="results" [descriptionLines]="2" [reachTheEnd]="reachTheEnd"
                (onRequestMoreSearchResults)="getMoreSearchResults()" (onResultClick)="onResultClick($event)">
            </app-list-results>

            <div class="news-display" [ngClass]="{'hidden': !showCurrentNews}" *ngIf="showCurrentNews">
                <div class="progressSpinnerContainer" [ngClass]="{'hidden': !loadingSearchNews}"></div>
                <div class="news-container" [ngClass]="{'hidden': loadingSearchNews}">
                    <div class="date-and-views-container">
                        <div class="date-views" *ngIf="currentNews?.PublishDate_OD as timestamp">
                            <i [ngClass]="{
                                'pi-thumbs-up-fill text-success': currentNews?.SentimentLabel === 'pos',
                                'pi-minus-circle text-warning': currentNews?.SentimentLabel === 'neu',
                                'pi-thumbs-down-fill text-danger': currentNews?.SentimentLabel === 'neg'
                            }" class="pi text-xl"></i>
                             {{ getPublishDate() | date:'dd MMMM yyyy HH:mm' }}
                            <div class="line-split"></div> <img src="assets/navbar-component-images/Show.svg" alt="">
                            {{0 || currentNews?.Views}}
                        </div>
                    </div>
                    <div class="news-data">
                        <h2>{{ currentNews?.Topic_OD }}</h2>
                    </div>
                    <img [src]="currentNews?.Picture_URL_OD" *ngIf="currentNews?.Picture_URL_OD"
                        [alt]="currentNews?.Picture_Alt_OD" (click)="onMouseLeave()">
                    <div *ngIf="loading && (source ? source : currentNews?.Link_OD)">
                        <p>แหล่งที่มา:
                            <span><a *ngIf="(source ? source : currentNews?.Link_OD?.match('https://www.'))"
                                    [href]="source ? source : currentNews?.Link_OD">{{ source ? source :
                                    currentNews?.Link_OD }}</a></span>
                            <span *ngIf="!(source ? source : currentNews?.Link_OD?.match('https://www.'))">{{ source ?
                                source : currentNews?.Link_OD }}</span>
                        </p>
                    </div>

                    <div class="wordsegment-container" *ngIf="showTags && isDirectSearch">
                        <app-wordsegment [searchQuery]="searchQuery"
                            (segmentedWordsChange)="onSegmentedWordsChange($event)"></app-wordsegment>
                    </div>

                    <div class="BreakLine"></div>

                    <p [innerHTML]="currentNews?.Detail_OD | highlighter: (currentNews ? currentNews.LOCATION : [])">
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="suggestion-container" [ngClass]="{'suggestion-container-active': newsSuggestions.length > 0}">
        <img class="arrow left-arrow" src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg"
            [ngStyle]="{ 'filter': 'invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(800%) contrast(150%)'}"
            (click)="scrollLeftt()" alt="Left Arrow">
        <div class="suggestions" #slider [ngClass]="{slider, 'dragging': isMove}" (mousedown)="startDragging($event)">
            <!---box for pin-->
            <div class="legend-box">
                <div class="legend-item">
                    <img src="assets/map-page-component-images/mainPin.svg">
                    <span>พิกัดข่าวปัจจุบัน</span>
                </div>
                <div class="legend-item">
                    <img src="assets/map-page-component-images/subPin.svg">
                    <span>พิกัดข่าวใกล้เคียง</span>
                </div>
            </div>

            <div class="suggestion" (click)="onNewsSuggestionClick(newsSuggestion)"
                *ngFor="let newsSuggestion of newsSuggestions">
                <img [src]="newsSuggestion.Picture_URL_OD" [alt]="newsSuggestion.Picture_Alt_OD"
                    [pTooltip]="tooltipContent" [tooltipDisabled]="newsSuggestion.LAT_LON_List != null"
                    tooltipPosition="top">
                <p-button (mouseover)="onMouseOver(newsSuggestion)" (mouseleave)="onMouseLeave()">
                    <img src="assets/map-page-component-images/subPin.svg">
                </p-button>
                <ng-template #tooltipContent>
                    <div [style]="{'width':'200px'}">
                        <span> ข่าวนี้ไม่มีตำแหน่งบนแผนที่ </span>
                    </div>
                </ng-template>
                <div class="title-container">
                    <img [src]="newsSuggestion.icon" [alt]="newsSuggestion.icon">
                    <h4>{{ newsSuggestion.Topic_OD }}</h4>
                </div>
            </div>
        </div>
        <img class="arrow right-arrow" src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg"
            [ngStyle]="{ 'filter': 'invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(800%) contrast(150%)'}"
            (click)="scrollRight()" alt="Right Arrow">
    </div>
</div>